import { useAuth0 } from '@auth0/auth0-react';
import Hotjar from '@hotjar/browser';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadMyProfileAsClient } from '../core/usecases/client-user-profile/loadMyProfileAsClient';
import { loadMyProfileAsHealer } from '../core/usecases/healer-settings/load-healer-user-profile';
import { selectCurrentUserId, selectIsHealer, selectShouldLoadCurrentUserProfile, setIsHealer } from '../store/selectors/global.selector';
import { hideLoader, showLoader } from '../store/selectors/loading-spinner-selector';

interface InterceptorRouteProps {
  element: ReactElement;
}

const LuminaraComponentWrapper: React.FC<InterceptorRouteProps> = ({ element, ...props }) => {
  const dispatch = useDispatch();
  const HEALER_ROUTE_PREFIX = '/healer/';
  const { isLoading, isAuthenticated, loginWithRedirect, user } = useAuth0();
  const [showScreen, setShowScreen] = useState(false);
  const shouldLoadUserProfile = useSelector(selectShouldLoadCurrentUserProfile);
  const currentUserId = useSelector(selectCurrentUserId);
  const isHealer = useSelector(selectIsHealer);

  useEffect(() => {
    dispatch(showLoader());
  }, [dispatch]);

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname.startsWith(HEALER_ROUTE_PREFIX)) {
      dispatch(setIsHealer(true));
    } else {
      dispatch(setIsHealer(false));
    }
  }, [dispatch, window.location.pathname]);

  useEffect(() => {
    if (!window.location.pathname.startsWith(HEALER_ROUTE_PREFIX)) {
      setShowScreen(true);
      dispatch(hideLoader());
    } else if (!isLoading) {
      if (!isAuthenticated) {
        dispatch(hideLoader());
        loginWithRedirect({ appState: { returnTo: window.location.pathname } });
      } else {
        dispatch(hideLoader());
        setShowScreen(true);
      }
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, window.location.pathname]);

  useEffect(() => {
    if (shouldLoadUserProfile) {
      if (!isHealer && currentUserId != null) {
        dispatch<any>(loadMyProfileAsClient(currentUserId));
      } else if (isHealer && !isLoading && user) {
        dispatch<any>(loadMyProfileAsHealer());
      }
    }
  }, [shouldLoadUserProfile, currentUserId, isHealer, dispatch, isLoading, user]);
  if (!showScreen) {
    return null;
  }
  return React.cloneElement(element, props);
};

export default LuminaraComponentWrapper;
